import { Card } from "../../models/card";
import { cards } from "../../state";
import { Golem } from "../upgrades/golem";
export class MakeGolem extends Card {
}
MakeGolem.displayName = "Golem";
MakeGolem.artUrl = "./assets/cards/golem.jpg";
MakeGolem.effect = {
    callback: () => {
        cards.push(new Golem({ x: 150, y: 240 }));
    },
    description: "Craft a Golem",
    needsFeedback: true,
};
MakeGolem.destroysOnPlay = true;
